export default __webpack_public_path__ + "static/FilsonSoftLight-Italic-5326efd24d0208c6ebfcbaa1b7ca1df9.ttf";